"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseQuery_1 = require("./BaseQuery");
var get_1 = require("../utils/get");
var Query_1 = require("./Query");
var object_1 = require("../utils/object");
var isArrayLike_1 = require("../utils/isArrayLike");
var transform_1 = require("./transform");
var JoinQuery = /** @class */ (function (_super) {
    __extends(JoinQuery, _super);
    function JoinQuery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.convertToArray = function (value) {
            if (typeof value !== 'undefined' && !isArrayLike_1.isArrayLike(value)) {
                return [value];
            }
            return value;
        };
        _this.applyTranforms = function (value, transforms, executionOptions) {
            if (transforms) {
                for (var _i = 0, transforms_1 = transforms; _i < transforms_1.length; _i++) {
                    var transformOptions = transforms_1[_i];
                    var transform = new transform_1.Transform(transformOptions, _this.translationHelper);
                    value = transform.execute(value, _this.queryOptions, executionOptions);
                }
            }
            return value;
        };
        return _this;
    }
    JoinQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, joinOptions = _a.joinOptions, subQueries = _a.subQueries, _b = _a.options, options = _b === void 0 ? {} : _b;
        var _c = joinOptions || {}, joins = _c.joins, sourceQueryId = _c.sourceQueryId, type = _c.type;
        return __assign({ sourceQueryId: sourceQueryId,
            joins: joins,
            type: type,
            subQueries: subQueries }, (options.join || {}));
    };
    JoinQuery.prototype.getRawValue = function (executionOptions) {
        var _a = this.options.type, type = _a === void 0 ? 'combine' : _a;
        if (type === 'combine') {
            return this.getCombineRawValue(executionOptions);
        }
        if (type === 'reduce') {
            return this.getReduceRawValue(executionOptions);
        }
    };
    JoinQuery.prototype.getReduceRawValue = function (executionOptions) {
        var _this = this;
        var _a = this.options.subQueries, subQueries = _a === void 0 ? [] : _a;
        var response = [];
        subQueries.forEach(function (subQueryOptions) {
            var subQuery = new Query_1.Query(subQueryOptions, _this.translationHelper);
            var subQueryValue = subQuery.execute(executionOptions);
            response.push.apply(response, _this.convertToArray(subQueryValue));
        });
        return response;
    };
    JoinQuery.prototype.getCombineRawValue = function (executionOptions) {
        var _this = this;
        var _a = this.options, subQueries = _a.subQueries, initialQueryId = _a.sourceQueryId, _b = _a.joins, joins = _b === void 0 ? [] : _b, _c = _a.type, type = _c === void 0 ? 'combine' : _c;
        if (!initialQueryId || !joins || joins.length === 0) {
            return [];
        }
        var subQueriesById = {};
        for (var subQueryIndex in subQueries) {
            var subQueryOptions = subQueries[subQueryIndex];
            var _d = subQueryOptions.queryId, queryId = _d === void 0 ? "subQuery" + subQueryIndex : _d;
            var subQuery = new Query_1.Query(subQueryOptions, this.translationHelper);
            var subQueryValue = subQuery.execute(executionOptions);
            subQueriesById[queryId] = this.convertToArray(subQueryValue);
        }
        var response = subQueriesById[initialQueryId] || [];
        var _loop_1 = function (join) {
            var destinationKey = join.destinationKey, destinationQueryId = join.destinationQueryId, sourceKey = join.sourceKey, _a = join.type, type_1 = _a === void 0 ? 'optional' : _a, rowTransforms = join.rowTransforms, valueTransforms = join.valueTransforms;
            var sourceCollection = __spreadArrays(response);
            var destinationCollection = subQueriesById[destinationQueryId] || [];
            response = [];
            var _loop_2 = function (sourceRow) {
                var sourceValue = get_1.get(sourceRow, sourceKey);
                var hasMatchingRow = false;
                destinationCollection.forEach(function (destinationRow) {
                    destinationRow = _this.applyTranforms(destinationRow, rowTransforms, executionOptions);
                    var destinationValue = _this.applyTranforms(get_1.get(destinationRow, destinationKey), valueTransforms, executionOptions);
                    var isMatch = sourceValue === destinationValue;
                    if (isMatch) {
                        hasMatchingRow = true;
                    }
                    if (isMatch || type_1 === 'outer') {
                        response.push(object_1.deepMergeObjectsWithOptions({ arrayMergeStrategy: 'DeepMerge' }, sourceRow, destinationRow));
                    }
                });
                if (type_1 === 'optional' && !hasMatchingRow) {
                    response.push(sourceRow);
                }
            };
            for (var _i = 0, sourceCollection_1 = sourceCollection; _i < sourceCollection_1.length; _i++) {
                var sourceRow = sourceCollection_1[_i];
                _loop_2(sourceRow);
            }
        };
        for (var _i = 0, joins_1 = joins; _i < joins_1.length; _i++) {
            var join = joins_1[_i];
            _loop_1(join);
        }
        return response;
    };
    return JoinQuery;
}(BaseQuery_1.BaseQuery));
exports.JoinQuery = JoinQuery;
//# sourceMappingURL=JoinQuery.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/query/JoinQuery.js
// module id = 412
// module chunks = 1